<div class="inline-search-wrapper" (click)="addToInlineSearchProps({value:hiddenValue})"></div>

<!-- Button to reveal hidden value -->
@if (!isValueVisible && !isLoading && !hasError && !isUnauthorized) {
  <button
    type="button"
    class="sem-hidden-value-button"
    (click)="onButtonClick()">
    {{buttonLabel}}
  </button>
}

<!-- Loading state -->
@if (isLoading) {
  <div class="sem-hidden-value-loading">
    <span>{{loadingText}}</span>
    <div class="loading-spinner"></div>
  </div>
}

<!-- Error state -->
@if (hasError && !isLoading && !isUnauthorized) {
  <div class="sem-hidden-value-error">
    <span>{{customErrorText || errorText}}</span>
    <button
      type="button"
      class="retry-button"
      (click)="onButtonClick()">
      Poskusi znova
    </button>
  </div>
}

<!-- Unauthorized state -->
@if (isUnauthorized && !isLoading) {
  <div class="sem-hidden-value-unauthorized">
    <span>{{unauthorizedText}}</span>
  </div>
}

<!-- Revealed value (readonly text display) -->
@if (isValueVisible && !isLoading && !hasError) {
  <div class="sem-hidden-value-display">
    <div class="hidden-value-input-wrapper">
      <input
        class="sem-text-box readonly-value hidden-input-with-icon"
        type="text"
        [value]="hiddenValue"
        readonly
        [title]="hiddenValue" />
        <button type="button"
          class="reveal-icon-btn-inside copy-btn"
          (click)="copyToClipboard()"
          title="Kopiraj v odložišče">
          <mat-icon>content_copy</mat-icon>
        </button>
      </div>
    </div>
  }

  <!-- Debug info (only shown if binding property name is visible) -->
  <p class="binding-prop-name">{{getAttribute('name')}}</p>